export class FetchXMLTemplateModel {
  TemplateName: string;
  FetchXmlTemplate: string;
}

export class FetchXMLTemplateRequest {
  templateNames: string[];
}